import React from 'react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, EffectFade, EffectCoverflow } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper-bundle.css';

SwiperCore.use([Navigation , EffectFade, A11y]);

class HomeSliderSection extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let page_id = this.props.page_id;
        let handleClickTop = this.props.handleClickTop;
        let sectionData = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.slider_section : [];
        let sliders = sectionData.slide && sectionData.slide.length ? sectionData.slide : [];
        let sliderData = sliders.map((item, key) => {
            let clr = item.background_color == 3 ? item.custom_color : '#869ab1';
            let clrcls = item.background_color == 1 ? 'bg-grn' : '';
            switch(Number(item.slide_type)){
                case 1:
                    return (
                        <SwiperSlide key={key}>
                            <figure className="fullScreen icenter"  style={{ backgroundColor: clr }}><img src={item.logo.url} width="508" alt={item.logo.alt} title={item.logo.title} /></figure>
                            <div className="bottom-content">
                                <div className="main-container">
                                    <a href={item.link} className="btn-arw right" target="_blank">{item.link_text}</a>
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                    break;
                case 2:
                    return (
                        <SwiperSlide key={key}>
                            <figure><img className="fullScreen" src={item.background_image.url} alt={item.background_image.alt} title={item.background_image.title} /></figure>
                            <h6 className="title text-center c-white posi-center" dangerouslySetInnerHTML={{__html:item.content}} />
                        </SwiperSlide>
                    )
                    break;
                case 3:
                    return (
                        <SwiperSlide key={key}>
                            <div className={`fullScreen c-white text-center ${clrcls}`}>
                                <div className="title posi-center" dangerouslySetInnerHTML={{__html:item.content}} />
                            </div>
                        </SwiperSlide>
                    )
                    break;
                case 4:
                    return (
                        <SwiperSlide key={key}>
                            <figure><img className="fullScreen" src={item.background_image.url} alt={item.background_image.alt} title={item.background_image.title} /></figure>
                        </SwiperSlide>
                    )
                    break;
                default:
                    break;
            }
            
        })

        return (
            <section className="section" data-hammenu="white">
                <div className="ll__gallery">
                    <Swiper effect="fade" loop={true} navigation>
                        {sliderData}
                    </Swiper>
                </div>
            </section>
        );
    }
}

export default HomeSliderSection;


// WEBPACK FOOTER //
// ./src/components/Home/HomeSliderSection.js